import { useQuery } from '@tanstack/react-query';

import { prophetTypes } from '../types';

import { axios } from '@/libraries/axios';
import { ExtractFnReturnType, QueryConfig } from '@/libraries/react-query';

export const getProphetKeywordStats: prophetTypes.GetProphetKeywordStats = (params) => {
  return axios.get(`/prophet/keyword-stats`, { params });
};

type QueryFnType = typeof getProphetKeywordStats;

type UseGetProphetKeywordStatsOptions = {
  pageId: string;
  config?: QueryConfig<QueryFnType>;
};

export const useGetProphetKeywordStats = ({
  config = {},
  pageId,
}: UseGetProphetKeywordStatsOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['prophet-keyword-stats', pageId],
    queryFn: () => getProphetKeywordStats({ pageId }),
  });
};
